import eventBus from 'js/eventBus';
import * as accEventBus from 'xcs-base-acc-client/src/descommon/src/js/accEventBus';

const ACC_SHOWCASE_EVENTID = 'accShowcaseEvent';
const eventNames = {
    // Catalog module
    desCatalogListSelectionChange: 'des-catalog-images-view.selectionChange',
    desCatalogPartSelectionChange: 'des-catalog-part-list.selectionChange',
    desCatalogListSelectionChangeForHomePage: 'des-catalog-home-page.selectionChange',

    // Search module
    desPartSelectionChange: 'des-search-results-list.selectionChange',
    // searchInitiated: 'desSearchResults',
    searchInitiated: 'des-catalog-search-box.initiated',
    getSearchResultsSuccess: 'desSearchResults.sucess',
    providerUpdate: 'desProviderUpdate',
    crumbClickEvent: 'crumbClickEvent',
    crumbClickedToNavigateToSearchResults: 'crumbClickedToNavigateToSearchResults',
    navigationTreeProviderSelectionChangeEvent: 'navigationTreeProviderSelectionChangeEvent',
    desSearchFilterSelectionChnage: 'des-search-filter.selectionChange',

    // Team module
    editTeamActionOpen: 'edit-team-action.open',
    desTeamListSelectionChange: 'des-Team-list.SelectionChange',
    desUpdateTeamSuccess: 'des-team-action.close',
    desCreateTeamSuccess: 'desCreateTeam.success',
    openTeamContent: 'des-team-content.open',
    TeamContentSuccess:'des-team-content.success',
    userListSelectionChangeCreateTeam:'des-create-team-sub-panel.selectionChange',
    userListSelectionChangeEditTeam:'des-edit-team-sub-panel.selectionChange',
    desStoreUsersSuccess:'desStoreUsers.Success',
    removeTeamAction: 'des-team-list.removeTeam',

    // Library module
    createLibraryFolderSuccess:'des-create-library-folder.success',
    desCreateLibrarySuccess: 'des-create-library.success',
    desLibraryListSelectionChange: 'des-library-list.selectionChange',
    desUpdateLibrarySuccess: 'des-update-library.success',
    shareLibraryToUsersSuccess: 'des-share-library-to-users.success',
    shareLibraryToTeamsSuccess: 'des-share-library-to-teams.success',
    desOpenLibrary: 'des-library-list.openLibrary',
    desEditLibrary: 'des-library-list.editLibrary',
    desLibraryPartSelectionChange:'des-list-library-content.selectionChange',
    listLibrariesSelectionChange: 'des-navigate-content-as-list.listLibrariesSelectionChange',
    desperfromImportSuccess:'des-upload-supplier-content.success',
    desperfromImportFailure:'des-upload-supplier-content.failure',
    desPublishLibrarySuccess:'des-publish-library.success',
    desPublishLibraryFailure:'des-publish-library.failure',
    // Catalog module
    desUsePartsInLibrariesSuccess: 'des-add-part-to-library.success'
};

/**
 * Publishes an event to ACC Event Bus
 * @param {String} eventId
 * @param {*} eventData
 */
export const publish = (eventId, eventData) => {
    let eventName = eventNames[eventId];
    if (!eventName) {
        eventName = eventId;
    }

    accEventBus.publish(eventName, eventData);

};

export const subscribe = (eventId) => {
    const eventName = eventNames[eventId] || eventId;
    window.addEventListener(eventName, (e) => {
        if (e.origin === window.location.origin ||
            (e.target && e.target.origin === window.location.origin)) {
            eventBus.publish(eventName, e.details);
        }
    });
};
